import SEO from "@/components/site/SEO";
import Hero from "@/components/sections/Hero";
import FeatureGrid from "@/components/sections/FeatureGrid";
import HowItWorks from "@/components/sections/HowItWorks";
import Solutions from "@/components/sections/Solutions";
import Stats from "@/components/sections/Stats";
import Testimonials from "@/components/sections/Testimonials";
import PricingTeaser from "@/components/sections/PricingTeaser";
import FAQ from "@/components/sections/FAQ";
import CTA from "@/components/sections/CTA";

export default function Home() {
  return (
    <div data-testid="page-home">
      <SEO
        title="Private Vehicle Contact. Powered by QR."
        description="SECQRE turns your windshield into a private contact line. Masked calls, instant alerts, zero phone-number exposure. Now launching in the United States."
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Product",
          name: "SECQRE Smart QR Vehicle Tag",
          description: "A QR sticker for your windshield. Lets anyone contact you about your parked car without seeing your phone number.",
          brand: { "@type": "Brand", name: "SECQRE" },
          offers: { "@type": "Offer", priceCurrency: "USD", price: "19" },
        }}
      />
      <Hero />
      <FeatureGrid />
      <HowItWorks />
      <Solutions />
      <Stats />
      <Testimonials />
      <PricingTeaser />
      <FAQ />
      <CTA />
    </div>
  );
}
